import { render, staticRenderFns } from "./booknow.vue?vue&type=template&id=c932856a&"
import script from "./booknow.vue?vue&type=script&lang=js&"
export * from "./booknow.vue?vue&type=script&lang=js&"
import style0 from "./booknow.vue?vue&type=style&index=0&id=c932856a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports